<template>
  <div>
    <div class="row">
      <div class="col">
        <h3>Create Associated Views</h3>

        <div class="row">
          <div class="col">
            <h4>How to use it:</h4>
            <p>Create an object model, add some properties, and then press the button below</p>
          </div>
          <div class="col">
            <h4>What it does:</h4>
            <ul class="list">
              <li>Adds current user to all default actions on object model, and creates the following:</li>
            </ul>
            <ul class="list">
              <li>
                A Folder named
                <strong>{{selectedObjectModel.title}} Folder</strong>
                <ul class="list">
                  <li>&nbsp;&nbsp;- All following created objects will go into this folder</li>
                </ul>
              </li>
              <li>
                A List View named
                <strong>{{selectedObjectModel.title}} LV</strong>
                <ul class="list">
                  <li>&nbsp;&nbsp;- Columns for each currently existing object model property</li>
                  <li>&nbsp;&nbsp;- Ability to create new records from LV</li>
                  <li>&nbsp;&nbsp;- Action column with Edit/Delete actions</li>
                  <li>&nbsp;&nbsp;- Short description</li>
                </ul>
              </li>
              <li>
                A Detail View named
                <strong>{{selectedObjectModel.title}} DV</strong>
                <ul class="list">
                  <li>&nbsp;&nbsp;- Rows for each currently existing object model property</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>

        <p v-if="errorMessage.length > 0">
          <pencil color="Red" >{{errorMessage}}</pencil>
        </p>

        <button
          class="btn green block"
          :disabled="createDisabled"
          @click="createAssociated"
        >Create Associated Objects</button>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import Vue from "vue";
import SelectedMixin from "../mixins/selectedMixin";

export default Vue.extend({
  mixins: [SelectedMixin],
  data: function() {
    return {
      buttonsDisabled: false,
      errorMessage: ""
    };
  },
  methods: {
    async createAssociated() {
      try {
        const res = await fetch(
          `/experimental/object_models/${this.selectedObjectModel.id}/create_associated_objects`,
          {
            method: "POST",
            headers: {
              "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
            }
          }
        );

        const json = await res.json();

        if (json.success) {
          const folder_id = json.created.folder_id;
          window.open(`/documents?folder=${folder_id}`);
        } else {
          this.errorMessage = "Sorry, something went wrong. Is your Object Model in the Archive folder?";
        }
      } catch (e) {
        this.errorMessage = "Sorry, something went wrong. ";
      }
      this.createDisabled = true;
    }
  }
});
</script>
